import { IDrawTextData } from '../interfaces';

export const drawTextLine = ({ context, xValue, yValue, text, maxWidth, fillStyle }: IDrawTextData): void => {
  context.fillStyle = fillStyle;
  context.fillText(text, xValue, yValue, maxWidth);
};
